// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"739ecb06","385":"01500b11","514":"f93fd40b","955":"8bb6b1db"}[chunkId] + ".chunk.js";
};